import { Form } from './form';
import { Config } from '../config';
import { QuantityForm } from './quantity-form';
import { FormTypes } from './form-types';
import { Order } from '../config/order';
import { Product } from '../config/product';
import { QuantityValidator } from '../validators/quantity-validator';
import { Price } from '../config/price';
import { ProductView } from '../view/product-view';
import { ProductType } from '../config/product-type';

export class AdaptivePricesForm extends Form {

    private products: Product[] = [];
    currentProduct: any = {};
    currentPrice: any = {};
    quantityForm: QuantityForm = new QuantityForm();
    quantity = 1;
    type = FormTypes.AdaptivePrices;
    view: ProductView = new ProductView();

    async init(config: Config, callbacks: any) {
        await super.init(config, callbacks);
        // this.currentProduct = this.config.products.find((product: Product) => product.prices) || {};

        if (this.config.products) {
            this.products = this.config.products.filter((product: Product) => {
                return (product.type === ProductType.SINGLE_PAYMENT
                    || (this.includeNoPayment() && product.type === ProductType.NO_PAYMENT))
                    && !product.addon;
            });

            this.currentProduct = this.products[0] || {};
        }
        if (this.products.every((product) => product.showQuantity)) {
            await this.quantityForm.init({}, {
                setQuantity: this.setQuantity.bind(this)
            });
            this.validators.push(new QuantityValidator());
        }

        this.setAmount();
        return Promise.resolve();
    }

    async render() {
        this.view.setConfig(this.config);
        if (this.products.length > 1) {
            this.view.renderMultipleProducts(this.products, this.onSelectedProductChange.bind(this));
        }

        this.currentProduct = this.products[0] || {};
        this.paymentData.amount = this.currentProduct.amount || 0;
        this.paymentData.type = this.currentProduct.type;
      
        if (this.products.every((product) => product.showQuantity)) {
            const quantityElementId = 'adaptive_prices';
            this.validationContext = { id: quantityElementId };
            await this.quantityForm.render(quantityElementId, this.currentProduct.name);
        }

        this.setAmount();
        return Promise.resolve();
    }

    async setAmount() {
        this.currentPrice = await this.getCurrentPrice();
        this.currentProduct.amount = this.currentPrice.amount;
        this.paymentData.amount = this.currentPrice.amount;
        this.paymentData.message = `One time fee: ${this.formatMoney(`${this.paymentData.amount}`, this.config.settings.currency)}`;
    }

    onSelectedProductChange(selectedProduct: any) {
        this.currentProduct = this.products.find((product) => product.name === selectedProduct.name);
        // this.paymentData.amount = +selectedProduct.value * this.quantity;
        if (this.quantityForm.setProductName) {
            this.quantityForm.setProductName(this.currentProduct.name);
        }

        this.paymentData.type = this.currentProduct.type;

        if (this.currentProduct.type === ProductType.NO_PAYMENT) {
            this.isNoPayment = true;
        } else {
            this.isNoPayment = false;
        }

        this.quantityForm.resetQuantity();
        this.quantityForm.quantity = 1;
        this.setQuantity();
    }

    private includeNoPayment() {
        return this.config.products.some((product: Product) => {
            return product.type !== ProductType.SUBSCRIPTION;
        });
    }

    async setQuantity() {
        await this.setAmount();
        if (this.quantityForm.quantity !== 0) {
            this.quantity = this.quantityForm.quantity;
        } else {
            this.quantity = 1;
        }

        if(this.currentProduct.prices[0].upToQuantity){
            this.currentPrice = this.getQuantityBasedPricing(this.quantity);
            this.currentProduct.amount = this.currentPrice.amount;
        }

        if(this.currentPrice.flatAmount){
            this.paymentData.amount = this.currentPrice.flatAmount;
        }else{
            this.paymentData.amount = this.quantity * this.currentPrice.amount;
        }

        this.paymentData.message = `One time fee: ${this.formatMoney(`${this.paymentData.amount}`, this.config.settings.currency)}`;
        this.triggerEvent('amountChange');
    }

    getQuantityBasedPricing(quantity: number) {
        const currentPrice = this.currentProduct.prices.sort((a:Price, b:Price) => {
            return a.upToQuantity - b.upToQuantity;
        }).find((price: Price) => {
            return price.upToQuantity >= quantity;
        });

        return currentPrice;
    }

    getDateBasedPricing(): Price {

        const timeNow = Date.now();

        const currentPrices = this.currentProduct.prices.filter((price: any) => {
            return Date.parse(price.endDate) > timeNow;
        });

        let currentPrice = currentPrices.find((price: any) => {
            return Date.parse(price.endDate) === Math.min.apply(null,
                currentPrices.map((item: any) => Date.parse(item.endDate)
                ));
        });

        if (!currentPrice) {
            currentPrice = this.currentProduct.prices.find((price: any) => price.endDate === '');
        }

        return currentPrice;
    }

    async getCurrentPrice() {

        if (this.currentProduct.showQuantity) {
            await this.quantityForm.init({}, {
                setQuantity: this.setQuantity.bind(this)
            });
            this.validators.push(new QuantityValidator());
        }

        if(this.currentProduct.prices[0].endDate === '' || this.currentProduct.prices[0].endDate){
            return this.getDateBasedPricing();
        }

        if(this.currentProduct.prices[0].upToQuantity){
            return this.getQuantityBasedPricing(this.quantity);
        }
    }

    getSelectedProducts() {
        return [ this.currentProduct ];
    }

    submit(order: Order) {
        if (this.currentProduct.showQuantity) {
            this.currentProduct.quantity = this.quantity;
        }
        order.selectedProducts.push(this.currentProduct);
        return Promise.resolve(order);
    }
}
